import { EmployeeRecord } from '../../utils/employee-indexeddb';
import { ApiKeyUsageData, ApiKeySummary } from './types';
import { generateHeadquarterHtmlReportWithComparison } from './report-comparison';

/**
 * Generate HTML report with API key usage data
 * This function delegates to generateHeadquarterHtmlReportWithComparison with empty previous data
 */
export function generateHeadquarterHtmlReportWithUsageData(
  employees: EmployeeRecord[],
  apiKeyUsage: ApiKeyUsageData[],
  reportTitle: string = 'API利用状況報告',
  reportPeriod: string = '過去30日間の利用状況',
  apiKeySummary?: ApiKeySummary,
  exchangeRate?: number | null
): string {
  // Delegate to the comparison version with empty previous data
  return generateHeadquarterHtmlReportWithComparison(
    employees,
    apiKeyUsage,
    [], // No previous period data
    reportTitle,
    reportPeriod,
    '',
    undefined,
    undefined,
    apiKeySummary ? { current: apiKeySummary } : undefined,
    exchangeRate
  );
}
